import { render } from "./App.vue?vue&type=template&id=f8a6a258"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f8a6a258&lang=css"
script.render = render

export default script